var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "38px",
    viewBox: "0 0 32 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5176\u4ED6_icons") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.358,0 L32,8.026 L32,35.45408 C32,36.8601528 30.8601528,38 29.45408,38 L2.54592,38 C1.13984721,38 1.72194254e-16,36.8601528 0,35.45408 L0,2.54592 C-1.72194254e-16,1.13984721 1.13984721,-1.07397625e-15 2.54592,0 L24.358,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5939394,0 C16.4173164,0 21.1549818,4.61260286 21.1878788,10.3142857 C21.1878788,16.0159686 16.4502133,20.6285714 10.5939394,20.6285714 C4.73766545,20.6285714 0,16.0159686 0,10.3142857 C0,4.61260286 4.73766545,0 10.5939394,0 Z M11.1515152,16.2857143 L11.1515152,14.6571429 L9.47878788,14.6571429 L9.47878788,16.2857143 L11.1515152,16.2857143 Z M13.0937244,9.29386629 L13.0936853,9.293888 C13.2857813,8.934712 13.3818182,8.51021943 13.3818182,8.02042114 C13.3818182,7.07349371 13.0616693,6.28980886 12.4534099,5.73470486 C11.8451227,5.17960086 11.044784,4.88571429 10.1163758,4.88571429 C9.66819636,4.88571429 9.25201067,4.98366743 8.83582497,5.11427886 C8.41963927,5.24488486 8.0354863,5.47344943 7.68332703,5.79998886 C7.33118448,6.12652829 7.10707248,6.48569886 6.94700921,6.877544 C6.78694594,7.26938371 6.72291952,7.759182 6.69090909,8.41224457 L6.69090909,8.60815629 L8.51571515,8.60815629 C8.61175758,7.20406171 8.99592727,6.42039314 10.0844044,6.42039314 C10.5966269,6.42039314 10.9807799,6.58367371 11.2689127,6.84489114 C11.5570512,7.10610314 11.685104,7.46529543 11.685104,7.92244629 C11.685104,8.248964 11.6210776,8.47754486 11.5250352,8.67345657 C11.3969879,8.86936829 11.076839,9.29386629 10.5326005,9.84897029 C9.95635152,10.4693746 9.57217624,10.9918257 9.38010255,11.4489711 C9.22001697,11.8734691 9.12398012,12.4285731 9.0919697,13.0489774 L9.12398012,13.5714286 L10.9487862,13.5714286 L10.7887229,13.0816303 C10.7887229,12.4612206 10.8527493,12.0693809 10.9487862,11.8408163 C11.0448286,11.6122517 11.3969879,11.1877591 11.9732368,10.6326551 C12.5174754,10.0775294 12.9016451,9.65305857 13.0937244,9.29386629 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5176\\u4ED6_icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "\\u77E9\\u5F62"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#A9ADBA",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DBDCDF",
    mask: "url(#mask-2)",
    x: 24,
    y: -6.55172414,
    width: 12,
    height: 14.4137931,
    rx: 1.27296
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u5206\\u7EC4",
    transform: "translate(5.575758, 8.461084)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "-2.78787879 -2.71428571 23.9757576 -2.71428571 23.9757576 23.3428571 -2.78787879 23.3428571"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.5b292b3bfd17013babd2f73b05f03b0d.svg";
export { ForwardRef as ReactComponent };